import { getCookie, setCookie } from './CookieHelper.js';

// UTM / campaign attribution capture.
//
// UTM values are not personal data, so capture/storage is NOT gated on consent
// (and is not cleared on rejection). The first touch remains in the hp_utm
// cookie while the most recent campaign in the current tab is held in
// sessionStorage. See docs/decisions/utm-tracking-plan.md.

const KEY = 'hp_utm';
const SESSION_KEY = 'hp_session_utm';
const TTL_DAYS = 30; // attribution window
const PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'gclid',
  'fbclid',
  'msclkid'
];

export function captureUtm() {
  const q = new URLSearchParams(window.location.search);
  const hasUtm = PARAMS.some((p) => q.get(p));
  const currentSessionUtm = readSessionUtm();
  const firstTouchUtm = readFirstTouchUtm();

  if (!hasUtm) {
    return currentSessionUtm || firstTouchUtm;
  }

  const utm = {
    source: q.get('utm_source') ?? '',
    medium: q.get('utm_medium') ?? '',
    campaign: q.get('utm_campaign') ?? '',
    term: q.get('utm_term') ?? '',
    content: q.get('utm_content') ?? '',
    gclid: q.get('gclid') ?? '',
    fbclid: q.get('fbclid') ?? '',
    msclkid: q.get('msclkid') ?? '',
    landingPath: window.location.pathname + window.location.search,
    firstReferrer: document.referrer || '',
    capturedAt: new Date().toISOString()
  };

  const isJobalert = utm.source.toLowerCase() === 'jobalert';

  // Jobalert owns the current tab without replacing the first-touch cookie. Once active,
  // a later explicitly tagged campaign replaces it for the remainder of this tab session.
  if (isJobalert || currentSessionUtm) {
    window.sessionStorage.setItem(SESSION_KEY, JSON.stringify(utm));
  }

  if (!firstTouchUtm) {
    setCookie(KEY, encodeURIComponent(JSON.stringify(utm)), TTL_DAYS);
  }

  return isJobalert || currentSessionUtm ? utm : firstTouchUtm || utm;
}

export function readUtm() {
  return readSessionUtm() || readFirstTouchUtm();
}

function readSessionUtm() {
  const raw = window.sessionStorage.getItem(SESSION_KEY);
  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw);
  } catch (_) {
    return null;
  }
}

function readFirstTouchUtm() {
  const raw = getCookie(KEY);
  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(decodeURIComponent(raw));
  } catch (_) {
    return null;
  }
}
